export default __webpack_public_path__ + "static/media/sort-me-telegram.bbe931a4.jpg";